/**
 @ngdoc directive
 @name communicationList

 @description
 Communication tile list page directive

 @usage
 <communication-list url="#####"></communication-list>

 @param {string}  url                       - Url to collect the communication JSON data

 */

(function() {
    'use strict';
    var communicationList = function ($templateCache, $http) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                url: "@",
                listCount: "@"
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/communicationList.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;

                _this.debug = false;
                _this.dataResponse = 'empty';
                _this.ajaxInProgress = true;
                _this.firstLoad = true;
                _this.ajaxState = 'IN_PROGRESS';

                //Setting up dates for time filtering
                var beginningOfToday = new Date();
                beginningOfToday.setHours(0,0,0,0);

                var beginningOfTodayValues = {
                    year: beginningOfToday.getFullYear(),
                    month: beginningOfToday.getMonth(),
                    day: beginningOfToday.getDate(),
                    hours: beginningOfToday.getHours()
                };

                var endOfToday = new Date();
                endOfToday.setHours(23,59,59,999);

                var yesterday = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month, beginningOfTodayValues.day - 1, beginningOfTodayValues.hours);
                var twoDaysInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month, beginningOfTodayValues.day - 2, beginningOfTodayValues.hours);
                var sixDaysInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month, beginningOfTodayValues.day - 6, beginningOfTodayValues.hours);
                var thirteenDaysInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month, beginningOfTodayValues.day - 13, beginningOfTodayValues.hours);
                var monthInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month - 1, beginningOfTodayValues.day + 1, beginningOfTodayValues.hours);
                var quarterInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month - 4, beginningOfTodayValues.day + 1, beginningOfTodayValues.hours);
                var sixMonthsInPast = new Date(beginningOfTodayValues.year, beginningOfTodayValues.month - 6, beginningOfTodayValues.day + 1, beginningOfTodayValues.hours);
                var yearInPast = new Date(beginningOfTodayValues.year - 1, beginningOfTodayValues.month, beginningOfTodayValues.day + 1, beginningOfTodayValues.hours);

                //Creating data for time filtering
                _this.timeFilters = [
                    {
                        name: "Any Time",
                        startDate: null,
                        endDate: null
                    },
                    {
                        name: "Last Day",
                        startDate: beginningOfToday,
                        endDate: endOfToday
                    },
                    {
                        name: "Last 2 Days",
                        startDate: yesterday,
                        endDate: endOfToday
                    },
                    {
                        name: "Last 3 Days",
                        startDate: twoDaysInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last Week",
                        startDate: sixDaysInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last Fortnight",
                        startDate: thirteenDaysInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last Month",
                        startDate: monthInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last Quarter",
                        startDate: quarterInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last 6 Months",
                        startDate: sixMonthsInPast,
                        endDate: endOfToday
                    },
                    {
                        name: "Last Year",
                        startDate: yearInPast,
                        endDate: endOfToday
                    }

                ];

                var CHECKBOX_FILTER_FACET_KEYS = ['statusKey','typeKey','createdByXmsLoginId','recipientsTypes', 'commsType'];
                /**
                 * Trying to key the get params small by excluding all the false values
                 * @param searchFilter
                 */
                var reduceSearchFilter = function (searchFilter) {
                    var reducedSearchFilter = {};
                    angular.forEach(searchFilter, function (searchFilterKeyVal, searchFilterKey) {
                        // Are you a checkbox filter?
                        if (CHECKBOX_FILTER_FACET_KEYS.includes(searchFilterKey)) {
                            var reducedValue = [];
                            // Loop through and keep the key for all that are true
                            angular.forEach(searchFilterKeyVal, function (checkBoxValue, checkBoxKey) {
                                if (checkBoxValue) {
                                    reducedValue.push(checkBoxKey);
                                }
                            });
                            reducedSearchFilter[searchFilterKey] = reducedValue
                        } else {
                            reducedSearchFilter[searchFilterKey] = searchFilterKeyVal;
                        }
                    });
                    return reducedSearchFilter;
                };

                /**
                 * Collects the comms (email & sms) data
                 * Current collects the comms (email & sms), filter facet, count and i18n label data all in one shot.
                 * Could be improved upon by seperating out but for now it will do
                 */
                var getDataList = function(){
                    _this.ajaxState = 'IN_PROGRESS';
                    _this.ajaxInProgress = true;
                    //var separator = _this.url.includes('?') ? '&' : '?';
                    var dataUrl = _this.url; /*
                    + separator +
                        'offset=' + _this.pagination.results.offset +
                        '&max=' + _this.pagination.results.max +
                        '&orderBy='+ _this.pagination.orderBy +
                        '&textContains='+_this.textContains
                        */
                    _this.lastDataUrl = dataUrl;
                    _this.lastParams = {
                        offset: _this.pagination.results.offset,
                        max: _this.pagination.results.max,
                        orderBy: _this.pagination.orderBy,
                        searchFilter: reduceSearchFilter(_this.searchFilter)
                    };

                    //Http request to get data list
                    $http({
                        method: 'GET',
                        url: dataUrl,
                        params: _this.lastParams
                    }).then(function successCallback(response) {
                        _this.dataResponse = response;
                        console.log('dataResponse',response)
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                        _this.firstLoad = false;
                        /*
                        console.log('dataResponse.data.pagination',_this.dataResponse.data.pagination);
                        console.log('pagination',_this.pagination);
                        console.log('pagination.results.size',_this.pagination.results.size);
                        */
                        _this.pagination.results.sizeChange(_this.dataResponse.data.pagination.results.size)
                        //generateFilterData(iteration, _this.dataResponse.data);
                        //checkDuplicates();

                    }, function errorCallback(response) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                };

                _this.searchFilter = {
                    textContains: '',
                    time: _this.timeFilters[0] //default time filter
                };

                /**
                 * When we start searching for text contains the speed slows down
                 * @returns {number}
                 */
                _this.expectedResultTime = function(){
                    return (_this.searchFilter.textContains)?5:2;
                };

                /**
                 * This should be converted into a service since the principles are the same very time.
                 * The only change would be setting the data request
                 * @type {{getDataList: getDataList, results: {max: number, offset: number, size: number, sizeChange: communicationList.pagination.results.sizeChange}, page: {total: number, current: number, currentChanged: communicationList.pagination.page.currentChanged, isSingle: communicationList.pagination.page.isSingle, goFirst: communicationList.pagination.page.goFirst, goPrevious: communicationList.pagination.page.goPrevious, isFirst: communicationList.pagination.page.isFirst, goNext: communicationList.pagination.page.goNext, goLast: communicationList.pagination.page.goLast, isLast: communicationList.pagination.page.isLast, updateTotal: communicationList.pagination.page.updateTotal, scrollToTop: communicationList.pagination.page.scrollToTop}}}
                 */
                _this.pagination = {
                    getDataList: getDataList,
                    orderBy: '',
                    results: {
                        max: 10, // This is the same as limit
                        offset: 0,
                        size: 0, // This will be set at initial call
                        sizeChange: function (size) {
                            _this.pagination.results.size = size;
                            _this.pagination.page.updateTotal();
                        }
                    },
                    page: {
                        total: 1,
                        current: 1,
                        // Updates the offset using the results list's current and max/limit
                        currentChanged: function () {
                            if (_this.pagination.page.current < 1 || _this.pagination.page.current > _this.pagination.page.total) {
                                _this.pagination.page.current = 1; //failover
                            }
                            _this.pagination.results.offset = (_this.pagination.page.current - 1) * _this.pagination.results.max;
                            _this.pagination.getDataList();
                            _this.pagination.page.scrollToTop();
                        },
                        // Do we only have a single page?
                        isSingle: function () {
                            return (_this.pagination.page.total<=1);
                        },
                        // Go to the first page
                        goFirst: function () {
                            _this.pagination.page.current = 1;
                            _this.pagination.page.currentChanged();
                        },
                        // Go to the previous page
                        goPrevious: function () {
                            _this.pagination.page.current--;
                            _this.pagination.page.currentChanged();
                        },
                        // Are we on first page?
                        isFirst: function(){
                            return (_this.pagination.page.current <= 1);
                        },
                        // Go to the next page
                        goNext: function () {
                            _this.pagination.page.current++;
                            _this.pagination.page.currentChanged();
                        },
                        // Go to the last page
                        goLast: function () {
                            _this.pagination.page.current = _this.pagination.page.total;
                            _this.pagination.page.currentChanged();
                        },
                        // Are we on last page?
                        isLast: function(){
                            return (_this.pagination.page.current >= _this.pagination.page.total);
                        },
                        // What is the current page
                        // getCurrent: function () {
                        //     return Math.ceil((_this.pagination.results.offset + 1) / _this.pagination.results.max);
                        // },
                        updateTotal: function () {
                            if (_this.pagination.results.size === 0) {
                                _this.pagination.page.total = 1;
                            } else {
                                _this.pagination.page.total = Math.ceil(_this.pagination.results.size / _this.pagination.results.max);
                            }
                        },
                        //Scroll to top, used for when pagination is switched
                        scrollToTop: function () {
                            window.scrollTo(0, 0);
                        }

                    }
                };

                _this.$onInit = function(){
                    _this.pagination.results.max = 10; // Default page size for pagination
                    _this.pagination.orderBy = "dateCreated"; // Default order by key

                    getDataList();
                };

            }]
        };
    };

    communicationList.$inject = ['$templateCache', '$http'];
    angular.module('app').directive('communicationList', communicationList);

}());
